const Step2 = () => {
  return <h1>Step 2</h1>;
};

export default Step2;
